const botUserAgents = [
    'oogle',
    'googlebot',
    'google-structured-data-testing-tool',
    'bingbot',
    'linkedinbot',
    'mediapartners-google',
    'AdsBot',
    'andex',
    'msnbot',
    'ambler',
    'yahoo',
    'mail.ru',
    'mailru',
];

const isBot = () => botUserAgents.some(ua => navigator.userAgent.match(ua));

export default isBot;
